module.exports = __webpack_public_path__ + "b604fed61183c73b923c68a5eb372a9b.pdf";